import { Plan } from '@models/membership/Plan'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { numberRule, requiredRule } from '@utils/rules'
import {
  Alert,
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Space,
  Switch,
  Typography,
} from 'antd'

const { Text } = Typography

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  const isFullAmount = Form.useWatch('fullAmount', form)
  return (
    <Form {...formProps} form={form} layout="vertical">
      <Space orientation="vertical" className="w-full">
        <Text>Code</Text>
        <Space.Compact className="w-full" style={{ marginBottom: 24 }}>
          <Form.Item
            name="code"
            rules={[requiredRule()]}
            label={'Code'}
            noStyle
          >
            <Input className="w-full" />
          </Form.Item>
          <Button
            type="primary"
            onClick={() =>
              form.setFieldValue(
                'code',
                Math.random().toString(36).slice(2, 10).toUpperCase()
              )
            }
          >
            Generate random code
          </Button>
        </Space.Compact>
      </Space>
      <Row>
        <Col span={4}>
          <Form.Item
            name="fullAmount"
            rules={[]}
            label={'Full amount'}
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
        </Col>
        <Col span={20}>
          <Form.Item
            label={'Fixed amount'}
            name="fixedAmount"
            rules={[numberRule()]}
            required
          >
            <InputNumber className="w-full" disabled={isFullAmount} />
          </Form.Item>
        </Col>
      </Row>
      <Alert
        type="info"
        title="Currency is based on the selected program"
        style={{ marginBottom: '24px' }}
      />
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item
            name="maxUsage"
            rules={[requiredRule()]}
            label={'Maximum usage'}
            initialValue={1}
          >
            <InputNumber className="w-full" min={1} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="useOnlyOnFirstCycle"
            rules={[]}
            label={'Use only on first cycle'}
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label={'Plans'} name="plans" rules={[requiredRule()]}>
            <SBAsyncSelect<Plan>
              entity={Entity.membershipPlan}
              multiple
              allowClear
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

export default Create
